import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import ServiceAreaForm from './ServiceAreaForm';
import BusinessInfoHoc from '../BusinessInfoHoc';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
};

const ServiceAreaContainer = ({ classes, businessAttributes }) => (
  <div className={classes.root}>
    <div className={classes.innerWrapper}>
      <div className={classes.personalWrapper}>
        <ServiceAreaForm businessAttributes={businessAttributes} />
      </div>
    </div>
  </div>
);

ServiceAreaContainer.propTypes = propTypes;

export default BusinessInfoHoc(withStyles(styles)(ServiceAreaContainer));
